export default __webpack_public_path__ + "static/media/kiosk-qr-scan.68c4e499.gif";